import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import SummaryApi from "../common";
import { toast } from "react-toastify";
// 1. Added AiOutlineArrowLeft to imports
import { AiFillEye, AiFillEyeInvisible, AiOutlineArrowLeft } from "react-icons/ai";

const TeamLeadHistory = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [showMobile, setShowMobile] = useState(false);

  const [tlStatus, setTlStatus] = useState("");
  const [reason, setReason] = useState("");
  const [nextFollowup, setNextFollowup] = useState("");
  const [leadDescription, setLeadDescription] = useState("");
  const [loadingDetails, setLoadingDetails] = useState(false);

  const { student, studentDetails, studentFollowUps } = state || {};
  const selectedStudent = student;

  const [followUps, setFollowUps] = useState(studentFollowUps || []);
  const [currentPage, setCurrentPage] = useState(1);
  const followUpsPerPage = 4;

  useEffect(() => {
    if (studentDetails) {
      // Pre-fill logic if needed
    }
  }, [studentDetails]);

  if (!student) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center">
          <p className="text-lg text-gray-700 mb-4">
            No student selected. Please go back to the previous page.
          </p>
          <button
            className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition duration-200"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!tlStatus) {
      toast.warn("⚠️ Please select a Call Status.");
      return;
    }

    if (!reason.trim()) {
      toast.warn("⚠️ Please enter a Call Reason.");
      return;
    }

    const empOrTlId =
      selectedStudent?.team_lead_emp_id || selectedStudent?.employee_id;

    if (!empOrTlId) {
      toast.error("No valid employee ID found for submission.");
      return;
    }

    const followUpPayload = {
      employee_id: empOrTlId,
      tl_student_followup_id: selectedStudent?.tl_student_followup_id || null,
      call_status: tlStatus,
      call_reason: reason.trim(),
    };

    const updateTlPayload = {
      tl_student_followup_id: selectedStudent?.tl_student_followup_id || "",
      next_followup_date_time: nextFollowup,
      lead_description: leadDescription,
      is_active: 1,
    };

    try {
      setLoadingDetails(true);

      const response1 = await fetch(SummaryApi.createStudentFollowDetails.url, {
        method: SummaryApi.createStudentFollowDetails.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer sandeep_university_916",
        },
        body: JSON.stringify(followUpPayload),
      });

      if (!response1.ok) throw new Error("Failed to create follow-up details");
      const data1 = await response1.json();

      if (!data1.status) {
        throw new Error(data1.message || "Failed to save follow-up details");
      }

      const response2 = await fetch(SummaryApi.updateTlFollowUp.url, {
        method: SummaryApi.updateTlFollowUp.method,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer sandeep_university_916",
        },
        body: JSON.stringify(updateTlPayload),
      });

      if (!response2.ok) throw new Error("Failed to update TL follow-up");
      const data2 = await response2.json();

      if (!data2.status) {
        throw new Error(data2.message || "Failed to update TL follow-up");
      }

      toast.success("✅ Follow-up details updated successfully!", {
        style: {
          background: "#f0fdf4",
          color: "#15803d",
          fontWeight: 500,
          borderLeft: "5px solid #22c55e",
        },
        icon: "📞",
      });
      setTimeout(() => navigate(-1), 1000);
      
      const newFollowUp = {
        stu_follow_id: data1.new_followup_id || Date.now(),
        followup_date: new Date().toLocaleDateString("en-CA"),
        call_status: tlStatus,
        call_reason: reason.trim(),
        followed_by: "You",
      };

      setFollowUps([newFollowUp, ...followUps]);
      setCurrentPage(1);

      setTlStatus("");
      setReason("");
      setNextFollowup("");
      setLeadDescription("");
    } catch (error) {
      toast.error(`❌ ${error.message}`, {
        style: {
          background: "#fef2f2",
          color: "#b91c1c",
          borderLeft: "5px solid #dc2626",
          fontWeight: 500,
        },
      });
    } finally {
      setLoadingDetails(false);
    }
  };

  const indexOfLast = currentPage * followUpsPerPage;
  const indexOfFirst = indexOfLast - followUpsPerPage;
  const currentFollowUps = followUps.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(followUps.length / followUpsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6 lg:p-8">
      <div className="max-w-8xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-8 lg:p-10">
        
        {/* 2. Added Back Button Here */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-600 hover:text-white-600 mb-6  duration-200 group bg-blue-800 text-white px-3 rounded "
        >
          <AiOutlineArrowLeft className="mr-2 text-xl group-hover:-translate-x-1 transition-transform" />
          <span className="font-semibold text-lg">Back</span>
        </button>

        <h3 className="text-3xl font-extrabold text-gray-800 mb-8 border-b-2 border-blue-200 pb-4">
          Update TL Status for{" "}
          <span className="text-blue-600">{selectedStudent?.student_name}</span>
        </h3>

        {loadingDetails ? (
          <div className="flex justify-center items-center h-48">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
            <p className="ml-4 text-lg text-gray-600">
              Loading student details...
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mb-10">
            {/* LEFT SIDE: Student Info */}
            <div className="p-5 bg-blue-50 rounded-lg shadow-sm">
              <h4 className="font-bold text-xl text-blue-800 mb-4 border-b border-blue-200 pb-2">
                Student Information
              </h4>
              {studentDetails ? (
                <div className="space-y-2 text-gray-700 text-base">
                  <p>
                    <strong className="text-blue-700">Enrollment :</strong>{" "}
                    {studentDetails.enrollment_code}
                  </p>
                  <p>
                    <strong className="text-blue-700">Student Name :</strong>{" "}
                    {studentDetails.student_name}
                  </p>
                 <p>
                    <strong className="text-blue-700">Guardian Name :</strong>{" "}
                    {studentDetails.father_name}
                  </p>
                  <p className="flex items-center gap-2">
                    <strong className="text-blue-700">Mobile :</strong>
                    <span>
                      {showMobile
                        ? studentDetails.mobile_number1
                        : "••••••••••"}
                    </span>
                    <button
                      type="button"
                      onClick={() => setShowMobile(!showMobile)}
                      className="text-blue-600 hover:text-blue-800 focus:outline-none"
                      title={showMobile ? "Hide Number" : "Show Number"}
                    >
                      {showMobile ? (
                        <AiFillEyeInvisible className="w-5 h-5" />
                      ) : (
                        <AiFillEye className="w-5 h-5" />
                      )}
                    </button>
                  </p>

                  <p>
                    <strong className="text-blue-700">District :</strong>{" "}
                    {studentDetails.district}
                  </p>
                  <p>
                    <strong className="text-blue-700">City :</strong>{" "}
                    {studentDetails.city}
                  </p>
                  <p>
                    <strong className="text-blue-700">College :</strong>{" "}
                    {studentDetails.clg_name}
                  </p>
                  <p>
                    <strong className="text-blue-700">Course :</strong>{" "}
                    {studentDetails.ug_pg_course}
                  </p>
                  <p>
                    <strong className="text-blue-700">Status :</strong>{" "}
                    {studentDetails.is_interested === "Most Interested" ? (
                      <span className="text-green-600 font-semibold px-2 py-1 rounded-full bg-green-100">
                        {studentDetails.is_interested}
                      </span>
                    ) : studentDetails.is_interested === "Interested" ? (
                      <span className="text-orange-600 font-medium px-2 py-1 rounded-full bg-orange-100">
                        {studentDetails.is_interested}
                      </span>
                    ) : (
                      <span className="text-gray-600 px-2 py-1 rounded-full bg-gray-100">
                        {studentDetails.is_interested || "Not Specified"}
                      </span>
                    )}
                  </p>
                  <p>
                    <strong className="text-blue-700">Followed up By : </strong>
                    {studentDetails.followed_up_by}
                  </p>
                  <p>
                    <strong className="text-blue-700">Remarks : </strong>
                    {studentDetails.remarks}
                  </p>
                </div>
              ) : (
                <p className="text-gray-500 text-base italic">
                  No detailed student information available.
                </p>
              )}
            </div>

            {/* RIGHT SIDE: Follow-up History */}
            <div className="p-5 bg-indigo-50 rounded-lg shadow-sm">
              <h4 className="font-bold text-xl text-indigo-800 mb-4 border-b border-indigo-200 pb-2">
                Follow-Up History
              </h4>
              {followUps.length === 0 ? (
                <p className="text-gray-500 text-base italic">
                  No follow-ups recorded yet for this student.
                </p>
              ) : (
                <>
                  <div className="space-y-4 max-h-96 overflow-y-auto pr-2 custom-scrollbar">
                    {currentFollowUps.map((fup) => (
                      <div
                        key={fup.stu_follow_id}
                        className="bg-white p-4 rounded-lg shadow-md border border-gray-200 hover:border-blue-300 transition-all duration-200"
                      >
                        <p className="text-sm text-gray-500 mb-1">
                          <strong className="text-gray-700">Date:</strong>{" "}
                          {fup.followup_date}
                        </p>
                        <p className="text-md text-gray-800 mb-1">
                          <strong className="text-gray-700">Status:</strong>{" "}
                          <span
                            className={`font-semibold ${
                              fup.call_status === "Contacted"
                                ? "text-green-600"
                                : fup.call_status === "Call Back"
                                ? "text-orange-600"
                                : "text-red-600"
                            }`}
                          >
                            {fup.call_status}
                          </span>
                        </p>
                        <p className="text-md text-gray-800 mb-1">
                          <strong className="text-gray-700">Reason:</strong>{" "}
                          {fup.call_reason}
                        </p>
                        <p className="text-sm text-gray-500">
  <strong className="text-gray-700">Next Follow up:</strong>{" "}
  {new Date(fup.next_followup_date_time).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })}
</p>

                        <p className="text-sm text-gray-500">
                          <strong className="text-gray-700">
                            Followed By:
                          </strong>{" "}
                          {fup.followed_by}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Pagination Buttons */}
                  {totalPages > 1 && (
                    <div className="flex justify-center mt-6 space-x-3">
                      {Array.from({ length: totalPages }, (_, i) => (
                        <button
                          key={i}
                          className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-medium transition-all duration-200
                                      ${
                                        currentPage === i + 1
                                          ? "bg-blue-600 text-white shadow-md"
                                          : "bg-gray-200 text-gray-700 hover:bg-blue-200 hover:text-blue-700"
                                      }`}
                          onClick={() => handlePageChange(i + 1)}
                        >
                          {i + 1}
                        </button>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {/* --- TL Update Form --- */}
        <div className="mt-10 p-6 bg-white rounded-lg shadow-lg border border-gray-200">
          <h4 className="text-2xl font-bold text-gray-800 mb-6 border-b border-gray-200 pb-3">
            Update Follow-up Status
          </h4>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label
                htmlFor="tlStatus"
                className="block text-gray-800 text-lg font-medium mb-2"
              >
                Call Status <span className="text-red-500">*</span>
              </label>
              <select
                id="tlStatus"
                value={tlStatus}
                onChange={(e) => setTlStatus(e.target.value)}
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 text-gray-700 text-base bg-gray-50"
              >
                <option value="">Select Status</option>
                <option value="Contacted">Contacted</option>
                <option value="Not Answered">Not Answered</option>
                <option value="Call Back">Call Back</option>
              </select>
            </div>

            <div>
              <label
                htmlFor="reason"
                className="block text-gray-800 text-lg font-medium mb-2"
              >
                Call Reason <span className="text-red-500">*</span>
              </label>
              <textarea
                id="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter detailed reason for the call..."
                rows="4"
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 text-gray-700 text-base resize-y bg-gray-50"
              ></textarea>
            </div>

            <div>
              <label
                htmlFor="nextFollowup"
                className="block text-gray-800 text-lg font-medium mb-2"
              >
                Next Follow-up Date & Time{" "}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="datetime-local"
                id="nextFollowup"
                value={nextFollowup}
                onChange={(e) => setNextFollowup(e.target.value)}
                required
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 text-gray-700 text-base bg-gray-50"
              />
            </div>

            <div>
              <label
                htmlFor="leadDescription"
                className="block text-gray-800 text-lg font-medium mb-2"
              >
                Lead Description
              </label>
              <textarea
                id="leadDescription"
                value={leadDescription}
                onChange={(e) => setLeadDescription(e.target.value)}
                placeholder="Add any important notes or a comprehensive description for the lead..."
                rows="4"
                className="w-full border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-blue-500 p-3 text-gray-700 text-base resize-y bg-gray-50"
              ></textarea>
            </div>

            {/* 3. Added Cancel Button next to Save */}
            <div className="flex justify-end pt-4 gap-4">
               <button
                type="button"
                onClick={() => navigate(-1)}
                className="px-8 py-3 bg-gray-200 text-gray-700 font-semibold rounded-lg shadow-md hover:bg-gray-300 focus:outline-none transition duration-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-75 transition duration-200 transform hover:scale-105"
              >
                Save Follow-up
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #a8a8a8;
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #7a7a7a;
        }
      `}</style>
    </div>
  );
};

export default TeamLeadHistory;